<div
  class="marker-wrapper"
  [class.selected]="selected"
  [class.mam-source]="isMamSourceMarker"
  (mousedown)="onWrapperClick($event)"
>
  <!-- Transparent hit area so the marker is easy to select (line is only 2px) -->
  <div class="marker-hit-area" aria-hidden="true"></div>
  <div class="marker-line" aria-hidden="true"></div>
  <div class="marker-label">
    <ng-container *ngIf="isMamSourceMarker">
      <span class="marker-text marker-text--readonly">{{ marker?.text }}</span>
    </ng-container>
    <input
      *ngIf="!isMamSourceMarker"
      type="text"
      class="marker-text"
      [value]="localText"
      (input)="onTextInput($event)"
      (blur)="onTextBlur($event)"
      (focus)="onTextFocus()"
      [style.width.ch]="Math.max(8, localText.length + 1) || 8"
    />
  </div>
</div>
